<template>
  <div class="node-manage">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <common-bg-plate>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="nodeList"
        :first-table-col="firstTableCol"
        :operator="operator"
        :operate-col="operateCol"
        :show-edit="true"
        :paging="nodePaging"
        @pagination="handleSizeOrPageChange"
        @handleSelectionChange="handleSelection"
      >
      </normal-table>
    </common-bg-plate>
    <add-node ref="addNode" @update:list="getList()"></add-node>
    <node-detail ref="nodeDetail"></node-detail>
    <terminal ref="terminal"></terminal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import addNode from './components/addNode'
import nodeDetail from './components/nodeDetail'
import terminal from './components/terminalDialog'
import auth from '@/auth/index'
export default {
  name: 'Index',
  components: {
    addNode,
    nodeDetail,
    terminal
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '增加节点',
          click: () => {
            return this.addNode()
          },
          icon: 'icon-add',
          auth: auth.node.addNode
        },
        {
          btnContent: '删除节点',
          click: () => {
            return this.deleteNode()
          },
          icon: 'icon-clear',
          auth: auth.node.deleteNode
        }
      ],
      // 设置table的列
      tableCol: [
        { 
          prop: 'id', 
          label: 'ID',
          minWidth: 97 
        },
        { 
          prop: 'name', 
          label: '名称',
          minWidth: 122 
        },
        {
          prop: 'addr',
          label: 'IP',
          formatter: row => {
            return this.formatIp(row, 'ip')
          },
          minWidth: 160
        },
        { 
          prop: 'path', 
          label: 'Path',
          minWidth: 125
        },
        {
          prop: 'userRole',
          label: '开放端口',
          formatter: row => {
            return this.formatIp(row, 'port') 
          },
          minWidth: 117
        },
        { 
          prop: 'chainId', 
          label: '运行区块链',
          minWidth: 88 
        },
        { 
          prop: 'nodeRole', 
          label: '角色',
          minWidth: 178 
        },
        { 
          prop: 'status', 
          label: '状态',
          minWidth: 122
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '详情',
          click: (row, col, cellValue) => {
            return this.getInfo(row)
          },
          icon: 'icon-check'
        },
        /*
        {
          text: '导入',
          click: (row, col, cellValue) => {
            return this.importCert(row)
          },
          icon: daoru
        },*/
        {
          text: '启动/重启',
          click: (row, col, cellValue) => {
            return this.restart(row)
          },
          icon: 'icon-play'
        },
        {
          text: '关闭',
          click: (row, col, cellValue) => {
            return this.close(row)
          },
          icon: 'icon-cancel',
          class: 'operate-danger'
        },
        {
          text: '远程管理',
          click: (row, col, cellValue) => {
            return this.remoteManage(row)
          },
          icon: 'icon-remote-manage'
        }
      ],
      operateCol: {
        minWidth: 127
      },
      firstTableCol: {
        select: true,
        type: 'selection',
        minWidth: 63
      },
      selectRows: []
    }
  },
  computed: {
    ...mapState({
      nodeList: state => state.node.node_list,
      nodePaging: state => state.node.node_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getNodeManageLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit
      }
      this.getNodeManageLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    getInfo(row) {
      this.$refs.nodeDetail.handleOpen(row)
    },
    getCertList(row) {
      this.$refs.certList.handleOpen(row.nodeCrtCid)
    },
    addNode() {
      this.$refs.addNode.handleOpen()
    },
    formatIp(row, type) {
      let val = row.addr.split(':')
      if (type === 'ip') {
        return val[0] || this.$constants.EMPTY
      } else {
        return val[1] || this.$constants.EMPTY
      }
    },
    importCert() {
      this.$router.push({
        name: 'certificate',
        query: {
          active: 'node'
        }
      })
    },
    deleteNode() {
      if (this.$utils.isEmpty(this.selectRows)) {
        this.$message.warning('请选择需要删除的节点！')
        return
      }
      let selectIds = this.selectRows.map(ele => {
        return ele.id
      })
      this.$confirm(
        '您正在删除已选中的全部节点，点击确定执行操作，删除后不可恢复，请谨慎选择，谢谢！ ',
        '删除节点',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }
      )
        .then(() => {
          this.$apis.node.deleteNode({ ids: selectIds }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getList(this.nodePaging.limit, this.nodePaging.offset)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //关闭
    close(row) {
      this.$confirm('此操作将关闭该主机, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$apis.node.operateNode({ id: row.id, op: 'stop' }).then(res => {
            this.$message({
              type: 'success',
              message: '关闭成功!'
            })
            this.getList(this.nodePaging.limit, this.nodePaging.offset)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取关闭'
          })
        })
    },
    //重启
    restart(row) {
      this.$confirm('此操作将启动该主机, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$apis.node.operateNode({ id: row.id, op: 'restart' }).then(res => {
            this.$message({
              type: 'success',
              message: '启动/重启成功!'
            })
            this.getList(this.nodePaging.limit, this.nodePaging.offset)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消启动'
          })
        })
    },
    //远程管理
    remoteManage(row) {
      this.$refs.terminal.handleOpen(row.id)
    },
    handleSelection(data) {
      this.selectRows = data
    }
  }
}
</script>

<style scoped lang="scss"></style>
